import classNames from 'classnames';
import BankLogo from './BankLogo';

interface InstallmentBank {
  bank: string;
  bank_logo_url?: string | null;
}

interface InstallmentBanksProps {
  promotions: InstallmentBank[];
  // Con el texto "Cuotas sin interés" al lado de los logos.
  withLabel?: boolean;
  className?: string;
}

// "Banco San Juan" y "San Juan", con o sin tildes, son el mismo banco.
export const bankKey = (bank: string) => bank.trim().toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/^banco\s+(de\s+(la\s+)?)?/, '')
  .replace(/\s+/g, ' ');

export const sameBank = (a: string, b: string) => bankKey(a) === bankKey(b);

// Un banco con promo en Payway y en Fiserv es el mismo banco para el comprador.
export const uniqueBanks = <T extends InstallmentBank>(promotions: T[]): T[] => {
  const seen = new Set<string>();
  return promotions.filter((promo) => {
    const key = bankKey(promo.bank);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

/**
 * "Cuotas sin interés" con los logos de los bancos, sin repetir bancos ni
 * detallar cuántas cuotas: el detalle se elige al pagar.
 */
const InstallmentBanks = ({ promotions, withLabel = true, className }: InstallmentBanksProps) => {
  const banks = uniqueBanks(promotions);
  if (banks.length === 0) {
    return null;
  }
  return (
    <div className={classNames('flex items-center gap-2', className)}>
      {/* Separados, no encimados: un logo con fondo transparente tapaba al de al lado. */}
      <span className="flex gap-1" aria-label={`Bancos: ${banks.map((promo) => promo.bank).join(', ')}`}>
        {banks.map((promo) => (
          <span key={promo.bank} title={promo.bank} className="rounded-full ring-1 ring-border-secondary">
            <BankLogo bank={promo.bank} logoUrl={promo.bank_logo_url} />
          </span>
        ))}
      </span>
      {withLabel && <span className="text-sm font-semibold text-success-700 dark:text-success-300">Cuotas sin interés</span>}
    </div>
  );
};

export default InstallmentBanks;
